
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"11","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.467 0c1.12 0 1.68 0 2.108.218a2 2 0 01.874.873c.218.428.218.988.218 2.108v4.268c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874c-.427.218-.988.218-2.108.218H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.873-.874C0 9.148 0 8.587 0 7.467V3.2c0-1.12 0-1.68.218-2.108A2 2 0 011.09.218C1.52 0 2.08 0 3.2 0h4.268zm.306 2.871a.715.715 0 00-1 0L5.318 4.324 3.894 2.87a.715.715 0 00-1 0c-.303.303-.303.757 0 1.03l1.424 1.42-1.424 1.423c-.284.284-.302.7-.053.976l.106.107c.276.248.692.23.947-.054L5.32 6.351l1.453 1.422a.664.664 0 00.947.054l.107-.107c.249-.275.231-.692-.053-.976L6.349 5.322 7.773 3.9c.303-.272.303-.726 0-1.029z","fill":"#BA000D"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      